// extracted by mini-css-extract-plugin
export default {"starterScreen":"Kp","starterImage":"Lp","already":"Mp","starterImageMobile":"Np","controlX":"Op","starterTextContain":"Pp","starterHeader":"Qp","starterBtn":"Rp","starterSecondaryBtn":"Sp","starterBanner":"Tp","mobileBtnContainer":"Up"};
    if(module.hot) {
      // 1743628922154
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  